import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';

import { Box } from '../box';
import { Button } from '../button';
import { Icon } from '../icon';
import { SegmentedControl } from '../segmented-control';
import { ShareContentObjectEditor } from './ShareContentObjectEditor';
import { ShareContentObjectRenderer } from '../feed-object/ShareContentObjectRenderer';
import { showAlert } from '../alert';
import { SOCIAL_NETWORKS, polling, openPopup } from '../../utils/share';
import { Text, H2 } from '../text';
import { ThemeConsumer } from '../theme';

export class Renderer extends React.Component {
  state = {
    scope: 'Network',
  };

  componentDidMount() {
    window.addEventListener('blur', this.onBlur);
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.onBlur);
  }

  onBlur = () => {
    clearTimeout(this.timeout);
  };

  onChangeScope = (scope) => {
    this.setState({ scope });
  };

  onSocialShare = (action) => {
    const { type, text_content } = this.props.item;
    const id = this.props.item[type].id;
    const socialNetwork = SOCIAL_NETWORKS.find((sn) => sn.name.toLowerCase() === action);
    const SHARE_URL = `${window.location.origin}/${type}s`;
    if (!socialNetwork) return;

    const text = text_content;
    const redirect_uri = `${SHARE_URL}/${id}${type === 'event' ? '/about' : ''}`;
    const url = socialNetwork.generateLink({ text, redirect_uri });

    if (action === 'email') {
      if (socialNetwork.alert) {
        this.timeout = setTimeout(() => {
          socialNetwork.alert();
        }, 500);
      }

      window.location.href = url;
    } else {
      polling(openPopup(url, socialNetwork.domain), null, socialNetwork.domain);
    }
  };

  renderSharedItem = (theme) => {
    return (
      <Box className="share-content-object__shared-item">
        <blockquote className="share-content-object__blockquote">
          <ShareContentObjectRenderer
            item={this.props.item}
            viewer={this.props.viewer}
            onRequestEventDetail={this.props.onRequestEventDetail}
          />
        </blockquote>
      </Box>
    );
  };

  renderNetwork = (theme) => (
    <Box>
      <ShareContentObjectEditor
        initialValues={{
          attachments: [],
          shared_content_object_id: this.props.item.id,
          editorState: {},
          pinned: false,
          post_in_communities: [],
          text_content: '',
        }}
        onSubmit={(object) => this.props.onCreateObject(object)}
        onSuccess={() => {
          showAlert({
            type: 'success',
            message: <Trans>The post has been successfully shared</Trans>,
          });
          this.props.onClose();
        }}
        viewer={this.props.viewer}
        fields={['html_content', 'attachments', 'pinned', 'emojis']}
      >
        {this.renderSharedItem(theme)}
      </ShareContentObjectEditor>
    </Box>
  );

  renderOtherNetworks = (theme) => (
    <Box>
      {this.renderSharedItem(theme)}
      <Box className="share-content-object__networks">
        {SOCIAL_NETWORKS.map(
          (socialNetwork) => (
            <Box
              key={socialNetwork.name.toLocaleLowerCase()}
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              className="share-content-object__networks__item"
            >
              <Box flexDirection="row" alignItems="center">
                <div style={{ width: 30 }}>
                  <Icon name={socialNetwork.icon_name} color={socialNetwork.icon_color} size={16} />
                </div>
                <Text color="#455A64" size="15px">
                  {socialNetwork.name}
                </Text>
              </Box>
              <Box>
                <div style={{ width: 100 }}>
                  <Button
                    block
                    type="button"
                    color={theme.color.brand}
                    onClick={() => this.onSocialShare(socialNetwork.name.toLocaleLowerCase())}
                    size="sm"
                    textColor="white"
                    title="Share"
                    id={`share-${socialNetwork.name.toLocaleLowerCase()}`}
                  />
                </div>
              </Box>
            </Box>
          ),
        )}
      </Box>
    </Box>
  );

  render() {
    const { item } = this.props;
    const labels = [this.props.t('Network')];

    if (['post', 'event'].includes(item.type)) {
      labels.push(this.props.t('Other networks'));
    }

    return (
      <ThemeConsumer>
        {(theme) => (
          <div className="share-content-object">
            <Box justifyContent="center" alignItems="center">
              <H2 size="22px" weight="300" style={{ marginTop: 0 }}>
                <Trans>Sharing Post</Trans>
              </H2>
              <div className="share-content-object__segmented">
                <SegmentedControl labels={labels} selectedLabel={this.state.scope} onChange={this.onChangeScope} />
              </div>

              {this.state.scope === 'Network' ? this.renderNetwork(theme) : this.renderOtherNetworks(theme)}
            </Box>
          </div>
        )}
      </ThemeConsumer>
    );
  }
}

export const ShareContentObject = withTranslation()(Renderer);
